export default "__VITE_ASSET__BKPJjxOH__"